import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LeadService } from '../../services/lead.service';
import { Broadcaster } from '../../services/broadcaster.service';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-lead-chooser',
  templateUrl: './lead-chooser.component.html',
})
export class LeadChooserComponent implements OnInit {
  leadSearchBar = new FormControl(); // the search bar input reference
  leads: any = []; // full leads list
  filteredOptions: Observable<any[]>; // filtered options after search
  selected: any = []; // selected leads list
  @Output() endChoosing = new EventEmitter<any>();
  public router;
  leadListReadySub: Subscription;
  savedObtionsSub: Subscription;
  savedObtionsLicensesSub: Subscription;

  constructor(
    private leadService: LeadService,
    private broadcaster: Broadcaster,
    private _router: Router,
  ) {
    this.router = _router;

    // get the leads, and store in leadList subject in Broadcaster Service
    this.leadListReadySub = this.broadcaster.leadList.subscribe(res => {
      for (let item of res) {
        if (item.name) {
          this.leads.push(item);
        }
      }
    });

    if (this.router.url === '/inbox') {
      this.savedObtionsSub = this.broadcaster.savedOptions.subscribe(data => {
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            var index = this.leads.findIndex(item => item.id === data[i].id);
            if (index != -1) {
              this.leads.splice(index, 1);
            }
          }
          this.filteredOptions = this.leadSearchBar.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value)),
          );
        } else {
          this.filteredOptions = this.leadSearchBar.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value)),
          );
        }
      });
    } else if (this.router.url === '/licenses') {
      this.savedObtionsLicensesSub = this.broadcaster.savedOptionsLicenses.subscribe(
        data => {
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              var index = this.leads.findIndex(item => item.id === data[i].id);
              if (index != -1) {
                this.leads.splice(index, 1);
              }
            }
            this.filteredOptions = this.leadSearchBar.valueChanges.pipe(
              startWith(''),
              map(value => this._filter(value)),
            );
          } else {
            this.filteredOptions = this.leadSearchBar.valueChanges.pipe(
              startWith(''),
              map(value => this._filter(value)),
            );
          }
        },
      );
    }
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (this.leadListReadySub) {
      this.leadListReadySub.unsubscribe();
    }
    if (this.savedObtionsSub) {
      this.savedObtionsSub.unsubscribe();
    }
    if (this.savedObtionsLicensesSub) {
      this.savedObtionsLicensesSub.unsubscribe();
    }
  }

  /**
   * @description check if option is related to the searched value, it checks if the searching value is in the option title or not
   * not necessarily in the beginning, it might be anywhere
   * @note if filtering array with no value then returns empty array
   * @param {string} value - to be checked with
   * @return {string[]} - filtered array that each item is matching the criteria
   * @private
   */
  private _filter(value: any): string[] {
    if (!value) return [];
    const filterValue = value.toLowerCase();
    return this.leads.filter(
      option => option.name.toLowerCase().indexOf(filterValue) != -1,
    );
  }

  /**
   * @description add the searched about lead to the selected list
   * @param lead
   */
  addToSelected(lead) {
    this.selected.push(lead);
    this.leads = this.leads.filter(value => lead.id != value.id);
    this.resetSearchBarValue();
    if (this.router.url != '/inbox') {
      this.disableSearchInput();
    }
    this.endChoosing.emit(this.selected);
  }

  /**
   * @description remove a lead from the selected leads list
   * @param lead
   */
  remove(lead) {
    this.leads.push(lead);
    this.selected = this.selected.filter(value => lead.id != value.id);
    this.endChoosing.emit(this.selected);
    this.enableSearchInput();
  }

  /**
   * @description to disable the search input
   */
  disableSearchInput() {
    this.leadSearchBar.disable();
  }

  /**
   * @description to enable the search input
   */
  enableSearchInput() {
    this.leadSearchBar.enable();
  }

  /**
   * @description reset the search bar value
   */
  resetSearchBarValue() {
    this.leadSearchBar.setValue('');
  }
}
